import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  setAuthToken(token: string) {
    localStorage.setItem('auth-token', token);
  }
  getAuthToken() {
    return localStorage.getItem('auth-token');
  }
  clearAuthToken() {
    localStorage.removeItem('auth-token');
  }
  setRefreshToken(token: string) {
    localStorage.setItem('refresh-token', token);
  }
  getRefreshToken() {
    return localStorage.getItem('refresh-token');
  }
  clearRefreshToken() {
    localStorage.removeItem('refresh-token');
  }
  getUser() {
    const user = localStorage.getItem('logged-user');
    return user ? JSON.parse(user) : null;
  }
  setUser(user: any) {
    localStorage.setItem('logged-user', JSON.stringify(user));
  }
  clearUser() {
    localStorage.removeItem('logged-user');
  }
}
